<template>
  <div>
    <partnerLink
      :partners="partners"
      :programs="programs"
      @getPartners="getPartners"
    />
  </div>
</template>

<script>
import partnerLink from "@/components/link/partner.vue";

export default {
  components: { partnerLink },
  data() {
    return {
      partners: [],
      programs: [],
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Partners" }]);
    this.initialise();
  },
  methods: {
    async initialise() {
      await Promise.all([this.getPrograms(), this.getPartners()]);
    },
    async getPartners() {
      await this.$axios
        .get("partners?level=P")
        .then((res) => {
          this.partners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrograms() {
      await this.$axios
        .get("programs")
        .then((res) => {
          this.programs = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>
